const en = {
  launchKicker: "Pre-launch sign-up",
  launchTitle: "The full app launches by 1 February 2027.",
  launchBody: "Right now we're testing the app and finalising partnership agreements. This is the time for businesses, sponsors and municipalities to sign up — and get 50% off as a launch partner.",
  launchCta: "Sign up now",
  testApp: "Try the test app",
  bandKicker: "For businesses",
  bandTitle: "Add your own trolls — 50% off for launch partners.",
  bandBody: "Hotels, cafés, saunas, shops and municipalities can sign up now and have their trolls ready when the app launches.",
  bandCta: "Sign up as a partner",
  kicker: "Sign up",
  title: "Put your trolls on the map.",
  lead: "Tell us who you are, pick a package and drop your trolls on the map. You pay with Vipps, and we get your trolls ready for launch.",
  role: "Who are you?",
  rolePh: "Choose…",
  roles: { homeowner: "Homeowner or private host", municipality: "Municipality, region or tourist board", sponsor: "Sponsor", other: "Other" },
  firstName: "First name",
  lastName: "Surname",
  company: "Company or organisation",
  optional: "optional",
  email: "Email",
  phone: "Phone",
  website: "Website",
  package: "Package",
  mapTitle: "Where do you want your trolls?",
  mapHint: "Search for your address, then tap the map to drop a troll. Drag a pin to move it.",
  search: "Search for an address or place in Norway",
  searchBtn: "Search",
  noResults: "No places found. Try another search.",
  placed: "{n} of {max} trolls placed",
  full: "All trolls are placed — remove one to move it, or pick a bigger package.",
  noPackage: "Choose a package first to see how many trolls you can place.",
  outside: "Trolls can only be placed in Norway.",
  pin: "Troll {n}",
  remove: "Remove",
  message: "Anything we should know?",
  messagePh: "Opening hours, troll ideas, questions…",
  consent: "I agree that Trollfossjakten stores these details to handle my sign-up. See the {privacy}.",
  submit: "Sign up and continue to payment",
  sending: "Sending…",
  summary: "Your order",
  pickPackage: "Choose a package to see your price.",
  payNote: "You pay with Vipps after signing up. Launch price: 50% off the first year.",
  errors: {
    phone: "Please enter a valid phone number (digits, +, spaces).",
    required: "Please fill in all required fields.",
    email: "Please enter a valid email address.",
    pins: "Please place at least one troll on the map.",
    consent: "Please accept how we store your details.",
    tooMany: "Too many sign-ups from this device. Please try again later.",
    generic: "Something went wrong. Please try again.",
  },
  doneKicker: "Thank you!",
  doneTitle: "You're signed up, {name}.",
  doneBody: "Your order number is {ref}. We've sent a copy to {email}. Pay with Vipps to secure your launch price.",
  doneBodyNoMail: "Your order number is {ref}. Keep it safe — pay with Vipps to secure your launch price.",
  another: "Sign up another place",
  payTitle: "Pay with Vipps",
  number: "Vipps number",
  amount: "Amount",
  ref: "Order number",
  copy: "Copy",
  copied: "Copied",
  exVat: "Price excl. VAT",
  vat: "VAT 25%",
  total: "Amount to pay",
  steps: ["Open Vipps and choose to send money", "Enter the number {number}", "Enter the amount {amount} kr", "In the message, write your order number {ref}"],
  invoice: "Prefer an invoice? Reply to the confirmation email and we'll send one.",
  host: { name: "Host place", for: "Café, farm, cabin, B&B, sauna or shop that welcomes troll hunters and accepts Troll Kroner", free: "Free" },
  mapTitleHost: "Where is your place — or where do you plan to open?",
  mapHintHost: "Search for your address, then tap the map to drop your pin. Drag it to move it.",
  placePin: "Your place",
  placedHost: "{n} of 1 place marked",
  fullHost: "Your place is marked — drag the pin to move it, or remove it first.",
  placeTitle: "Your place",
  placeBody: "Tell troll hunters what you offer and tick everything you have.",
  offer: "What will you offer?",
  offerPh: "e.g. coffee and waffles, sauna, rooms for the night",
  amenitiesTitle: "What do you have? Tick all that apply",
  amenities: { coffee: "Coffee", tea: "Tea", snacks: "Snacks", restaurant: "Restaurant", conversations: "Conversations", phone_charging: "Phone charging", bike_charging: "E-bike charging", car_charging: "EV car charging", shower: "Shower", room: "Room", sauna: "Sauna", bnb: "Bed & breakfast", hotel: "Hotel", camping: "Camping", parking: "Parking", toilet: "Toilet", wifi: "Wifi" },
  hostNote: "Being a host is free — no payment and no sign-up fee. We check your details and put your place on the map.",
  submitHost: "Register as a host",
  offerError: "Please tell us what you will offer.",
  hostDoneTitle: "You're registered as a host, {name}.",
  hostDoneBody: "Your reference is {ref}. We've sent a copy to {email}. We'll check your details and put your place on the map.",
  hostDoneBodyNoMail: "Your reference is {ref}. Keep it safe — we'll check your details and put your place on the map.",
  hostNextTitle: "What happens next",
  hostNext: ["Download the app and sign in with the same email.", "Go to Profile → Become a host to start accepting Troll Kroner.", "Scan a guest's payment QR — the app works out the rest to pay."],
  hostGetApp: "Get the app",
};

export default en;
